// Navbar dropped in from FullStackRocket... and updated jss-to-styled. muiV5

import React from 'react';
import { Link } from 'gatsby';
import { styled } from '@mui/system';
import AppBar from '@mui/material/AppBar';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import useSiteMetadata from './SiteMetadata';
import ArrowDropDownTwoToneIcon from '@mui/icons-material/ArrowDropDownTwoTone';
import MUILink from '@mui/material/Link';
import theme from '../theme';

const drawerWidth = 240;

// const useStyles = makeStyles((theme) => ({
// root: {
// 	display: 'flex',
// },
const DrawerNav = styled('nav')(({ theme }) => ({
	[theme.breakpoints.up('sm')]: {
		width: drawerWidth,
		flexShrink: 0,
	},
}));

const AppBarStyled = styled(AppBar)(({ theme }) => ({
	backgroundColor: theme.palette.background.default,
	[theme.breakpoints.up('sm')]: {
		width: `100%`,
	},
}));
const MainToolbar = styled(Toolbar)(({ theme }) => ({
	justifyContent: 'space-around',
	transition: 'all 0.5s ease',
	'.MuiButtonBase-root': {
		borderRadius: 0,
		':hover': {
			transition: 'all 0.5s ease',
			backgroundColor: 'rgba(255,255,255,0.05)',
		},
	},
	'& a': {
		color: theme.palette.text.primary,
		'&:hover': {
			textDecoration: 'none',
		},
	},
	[theme.breakpoints.down('sm')]: {
		justifyContent: 'space-between',
	},
}));

const items = [
	{ path: '/#AboutV2', label: 'Who? What?' },
	{
		path: '',
		label: 'Solutions',
		subs: [
			{ path: 'https://continuouscompliance.au/', label: 'Continuous Compliance' },
			{ path: 'https://continuouscompliance.au/', label: 'Essential 8 Compliance' },
		],
	},
	{ path: '/#toolBox', label: 'The Toolbox' },
	// { path: '/', label: 'Uses of ALEiGN' },
	// { path: '/', label: 'The Cost' },
	// { path: '/', label: 'Contact' },
	// {
	// 	path: '',
	// 	label: 'Dig Deeper',
	// 	subs: [
	// 		{ path: '/classes', label: 'The Cinema' },
	// 		{ path: '/fees', label: 'The Library' },
	// 	],
	// },
	{ path: '/get-in-touch', label: 'Signup / Login' },
];

export default function NavBarComponent(props) {
	const { container } = props;
	const { title, mainLogo } = useSiteMetadata();
	const [mobileOpen, setMobileOpen] = React.useState(false);

	const handleDrawerToggle = () => {
		setMobileOpen(!mobileOpen);
	};
	const [anchorEl, setAnchorEl] = React.useState();

	const handleClick = (target, label) => {
		setAnchorEl({
			[label]: target,
		});
	};
	const handleClose = () => {
		setAnchorEl(null);
	};
	const drawer = (
		<div>
			<Box sx={(theme) => theme.mixins.toolbar} />
			<List>
				{items.map((item, i) => (
					<ListItem button key={`${item.path}-item-${i}`}>
						<MUILink component={Link} to={item.path}>
							<ListItemText primary={item.label} />
						</MUILink>
					</ListItem>
				))}
				<ListItem button key='contactDraw'>
					<MUILink onClick={() => window.FreshworksWidget('open')}>
						<ListItemText primary='Contact' />
					</MUILink>
				</ListItem>
			</List>
		</div>
	);

	return (
		<>
			<AppBarStyled position='sticky'>
				<MainToolbar>
					<Link to='/'>
						<img
							src={mainLogo}
							alt={title}
							style={{ width: '145px', margin: '7px 0 0' }}
						/>
					</Link>
					<List sx={{ display: { xs: 'none', md: 'flex' }, height: '100%', py: 0 }}>
						{items.map((item, i) => (
							// <Tooltip
							// 	id={item.name}
							// 	title={item.toolTip}
							// 	placement={
							// 		typeof window !== 'undefined' && window.innerWidth > 959
							// 			? 'top'
							// 			: 'left'
							// 	}
							// 	sx={{ display: item.toolTip ? 'block' : 'none' }}
							// >
							<ListItem
								variant="navItem"
								button
								key={`${item.path}-item-${i}`}
							>
								<Button
									id='basic-button'
									aria-controls={
										anchorEl && Boolean(anchorEl[item.label])
											? 'basic-{item.label}'
											: undefined
									}
									aria-haspopup='true'
									aria-expanded={
										anchorEl && Boolean(anchorEl[item.label]) ? 'true' : undefined
									}
									onClick={(event) => handleClick(event.currentTarget, item.label)}
									sx={{
										justifyContent: 'center',
										width: 'max-content',
										px: 2,
									}}
									href={item.path}
								>
									{item.label ? <span>{item.label}</span> : null}
									<ArrowDropDownTwoToneIcon
										sx={{ display: item.subs ? 'block' : 'none' }}
									/>
								</Button>
								<>
									{item.subs ? (
										<Menu
											disablePadding
											disableGutters
											key={`${item.path}-subs`}
											id={`basic-${item.label}`}
											anchorEl={anchorEl && anchorEl[item.label]}
											open={Boolean(anchorEl && anchorEl[item.label])}
											onClose={handleClose}
											MenuListProps={{
												'aria-labelledby': 'basic-button',
											}}
											sx={{
												'.MuiMenu-list': {
													padding: 0,
													backgroundColor: theme.palette.background.default,
												},
												'.MuiMenuItem-root': { fontSize: '1rem' },
											}}
										>
											{item.subs?.map((sub, i) => (
												<MenuItem
													key={`${item.path}-subs-${i}`}
													onClick={handleClose}
													component="a"
													href={sub.path}
													target="_blank"
													rel="noopener noreferrer"
												>
													{sub.label}
												</MenuItem>
											))}
										</Menu>
									) : null}
								</>
							</ListItem>

							//  </Tooltip>
						))}
						<ListItem
							sx={{
								p: 0,
								// color: '#fff',
								'&:hover': { backgroundColor: 'rgba(0,0,0,0.26)' },
							}}
							button
							key='contact1'
						>
							<Button
								id='basic-button'
								onClick={() => window.FreshworksWidget('open')}
								sx={{
									justifyContent: 'center',
									width: 'max-content',
									// color: '#fff',
									px: 2,
								}}
							>
								<span>Contact</span>
							</Button>
						</ListItem>
					</List>
					<IconButton
						// color='inherit'
						aria-label='open drawer'
						edge='end'
						onClick={handleDrawerToggle}
						sx={{ display: { xs: 'block', md: 'none' } }}
					>
						<MenuIcon />
					</IconButton>
				</MainToolbar>
			</AppBarStyled>
			<DrawerNav aria-label='mailbox folders'>
				{/* The implementation can be swapped with js to avoid SEO duplication of links. */}
				<Drawer
					container={container}
					variant='temporary'
					anchor={'right'}
					open={mobileOpen}
					onClose={handleDrawerToggle}
					// classes={{
					// 	paper: classes.drawerPaper,
					// }}
					sx={{
						display: { md: 'none' },
						'& .MuiDrawer-paper': { width: drawerWidth },
					}}
					ModalProps={{
						keepMounted: true, // Better open performance on mobile.
					}}
				>
					{drawer}
				</Drawer>
			</DrawerNav>
		</>
	);
}
